<template>
    <div 
        v-if="facet.name" 
        class="card" 
        :class="facet.cssClass" 
        ref="dropdown" 
        @click.stop
    >
        <div
            class="h3 facet-title"
            :class="{ active: isOpen }"
            role="button"
            @click="toggleDropdown"
            :aria-expanded="isOpen"
            :aria-controls="'facet-collapse-' + _uid"
        >
            {{ facetName }}
            <!-- <span class="ms-2" :class="{'rotate-180': isOpen}">
                <i class="fa fa-chevron-down"></i>
            </span> -->
        </div>

        <div :id="'facet-collapse-' + _uid" class="collapse filter-dropdown mt-2 mt-md-0" :class="{ show: isOpen }">
            <div v-if="facet.type === 'price'">
                <item-filter-price></item-filter-price>
            </div>
            <div v-else class="form-check-wrapper" v-for="value in facets" :key="value.id" :class="value.cssClass">
                <div class="form-check mb-0 ps-0">
                    <input :id="'option-' + value.id + '-' + _uid" class="form-check-input d-none" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                    <label 
                    :for="'option-' + value.id + '-' + _uid" 
                    class="form-check-label d-flex justify-content-between align-items-center w-100"
                    :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance font-weight-bold' : '', 'option-' + value.id]" 
                    :style="paddingInlineStyles">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <span class="flex-grow-1">{{ value.name }}</span>
                            <div class="filter-badge">{{ value.count }}</div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {

    name: "item-filter",

    components:
    {
        ItemFilterPrice
    },

    props:
    {
        facet:
        {
            type: Object
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isOpen: false
        };
    },

    computed:
    {
        facets()
        {
            return this.facet.values;
        },

        facetName()
        {
            if (this.facet.translationKey && this.facet.translationKey.length > 0)
            {
                return this.$translate("Ceres::Template." + this.facet.translationKey);
            }

            return this.facet.name;
        },

        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets,
            isLoading: state => state.itemList.isLoading
        })
    },

    methods:
    {
        toggleDropdown() {
            if (this.isOpen) {
                this.isOpen = false;
            } else {
                window.dispatchEvent(new CustomEvent('closeAllDropdowns'));
                this.isOpen = true;
            }
        },
        handleClickOutside(event) {
            if (this.isOpen && this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false;
            }
        },
        closeDropdown() {
            this.isOpen = false;
        },
        updateFacet(facetValue)
        {
            const toolbarElements = document.getElementsByClassName("widget-toolbar");

            for (const toolbarElement of toolbarElements)
            {
                if (toolbarElement.contains(this.$vnode.elm))
                {
                    window.localStorage.setItem("openFilterToolbar", true);
                }
            }

            this.$store.dispatch("selectFacet", { facetValue });
        },

        isSelected(facetValueId)
        {
            return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
        window.addEventListener('closeAllDropdowns', this.closeDropdown);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener('closeAllDropdowns', this.closeDropdown);
    }
}
</script>
